const originConsoleError = console.error;
let errors: any[] = [];

const ignoredErrors = [
  'findDOMNode is deprecated',
  'uses the legacy childContextTypes API which is no longer supported',
  'uses the legacy contextTypes API which is no longer supported',
];

console.error = (...args: [any?, ...any[]]) => {
  const shouldIgnoreError = args.some(
    (arg) =>
      typeof arg === 'string' &&
      ignoredErrors.some((ignoredError) => arg.includes(ignoredError)),
  );

  if (!shouldIgnoreError) {
    errors.push(args);
  }

  originConsoleError.apply(console, args);
};

export const consoleErrors = {
  reset: () => (errors = []),
  get: () =>
    errors.slice().map((args) =>
      args.reduce((acc: string, arg: any) => {
        return acc + arg;
      }, ''),
    ),
};

beforeEach(() => (errors = []));

afterEach(() => {
  if (errors.length > 0) {
    throw new Error(`Test has ${errors.length} Unhandled Errors:\n${errors}`);
  }
});
